<template>
  <button-base medium="messenger" :title="i18n.t('public.social.share_on_messenger')"
               icon-filename="messenger-black.svg" class="messenger d-md-none" @click="handleClick" />
</template>

<script>
import ButtonBase from './button-base'
import MessengerMixin from '@/share/campaign/messenger-mixin'

export default {
  components: { ButtonBase },

  mixins: [MessengerMixin]
}
</script>
